import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { Autoplay, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import Meta from "../../components/Meta";
import namx_news_data from "../../data/namx_news_data";

const Single_news = () => {
  const [allNews, setAllNews] = useState([]);
  const router = useRouter();
  const id = router.query.single_news;

  useEffect(() => {
    const filteredNews = namx_news_data.filter((news) => news.id === id);
    setAllNews(filteredNews);
  }, [id]);

  const handleNavigate = (direction) => {
    const currentIndex = parseInt(id);
    console.log(currentIndex);
    if (direction === "previous") {
      router.push(`/single_news/${currentIndex - 1}`);
    } else {
      router.push(`/single_news/${currentIndex + 1}`);
    }
  };

  return (
    <section className="pt-[5.5rem] lg:pt-16">
      <Meta title="News" />
      {allNews.map((news) => (
        <div
          key={news.id}
          className="max-w-screen-xl mx-auto p-5 sm:p-10 md:p-16 relative"
        >
          <Swiper
            navigation
            modules={[Navigation, Autoplay]}
            autoplay={{ delay: 2500 }}
            className="mySwiper"
          >
            {news?.images.map((image, index) => (
              <SwiperSlide key={index}>
                <PhotoProvider>
                  <PhotoView src={image}>
                    <div
                      className="bg-cover bg-center text-center overflow-hidden rounded"
                      style={{
                        minHeight: "500px",
                        backgroundImage: `url(${image})`,
                      }}
                      title={`news_image_${index}`}
                    ></div>
                  </PhotoView>
                </PhotoProvider>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="max-w-3xl mx-auto">
            <div className="relative z-10 mt-3 bg-white dark:bg-jacarta-700 backdrop-blur rounded-b lg:rounded-b-none lg:rounded-r flex flex-col justify-between leading-normal">
              <div className="bg-white dark:bg-jacarta-700 shadow-xl backdrop-blur relative top-0 -mt-32 p-5 sm:p-10 rounded">
                <h1
                  href="#"
                  className="text-gray-900 font-bold text-2xl lg:text-3xl mb-2"
                >
                  {news.title}
                </h1>
                <div className="py-4 space-y-3">
                  <p>
                    {" "}
                    Published Date:
                    <span className="font-semibold"> {news.date}</span>
                  </p>
                  <p>
                    Written By:{" "}
                    <span className="font-semibold">The Namx Team</span>
                  </p>
                </div>
                <p
                  className="space-y-4"
                  dangerouslySetInnerHTML={{ __html: news.description }}
                ></p>
              </div>
              <div className="flex gap-4 pb-6 pr-8 justify-end">
                <button
                  onClick={() => handleNavigate("previous")}
                  className={`px-4 py-2 border rounded-lg ${
                    id === "1" && "hidden"
                  }`}
                >
                  Previous
                </button>
                <button
                  onClick={() => handleNavigate("next")}
                  className={`px-4 py-2 border rounded-lg ${
                    id === namx_news_data.length.toString() && "hidden"
                  }`}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Single_news;
